import axios from '../config/axiosConfig';

const API_URL = '/web-vuln-scans';

/**
 * Create a new vulnerability scan
 */
const createScan = async (scanData) => {
  const response = await axios.post(API_URL, scanData);
  return response.data;
};

/**
 * Start a scan (async)
 */
const startScan = async (scanId) => {
  const response = await axios.post(`${API_URL}/${scanId}/start`);
  return response.data;
};

/**
 * Get scan progress status
 */
const getStatus = async (scanId) => {
  const response = await axios.get(`${API_URL}/${scanId}/status`);
  return response.data;
};

/**
 * Get scan results (findings)
 */
const getResults = async (scanId) => {
  const response = await axios.get(`${API_URL}/${scanId}/results`);
  return response.data;
};

/**
 * Pause a running scan
 */
const pauseScan = async (scanId) => {
  const response = await axios.post(`${API_URL}/${scanId}/pause`);
  return response.data;
};

/**
 * Resume a paused scan
 */
const resumeScan = async (scanId) => {
  const response = await axios.post(`${API_URL}/${scanId}/resume`);
  return response.data;
};

/**
 * Cancel a scan
 */
const cancelScan = async (scanId) => {
  const response = await axios.post(`${API_URL}/${scanId}/cancel`);
  return response.data;
};

/**
 * List scans with optional filters
 */
const listScans = async (webTargetId, status, projectId) => {
  const params = {};
  if (webTargetId) params.webTargetId = webTargetId;
  if (status) params.status = status;
  if (projectId) params.projectId = projectId;

  const response = await axios.get(API_URL, { params });
  return response.data;
};

/**
 * Get single scan details
 */
const getScan = async (scanId) => {
  const response = await axios.get(`${API_URL}/${scanId}`);
  return response.data;
};

/**
 * Delete a scan
 */
const deleteScan = async (scanId) => {
  const response = await axios.delete(`${API_URL}/${scanId}`);
  return response.data;
};

/**
 * Create Actions from findings (bulk operation)
 */
const createActionsFromFindings = async (findingIds) => {
  const response = await axios.post(`${API_URL}/findings/create-actions`, { findingIds });
  return response.data;
};

/**
 * Update SIEM correlation for findings (bulk operation)
 */
const updateSIEMCorrelation = async (findingIds, siemData) => {
  const response = await axios.post(`${API_URL}/findings/siem-correlation`, {
    findingIds,
    siemData
  });
  return response.data;
};

/**
 * Per-URL control (pause | resume | cancel) for a single URL in a scan.
 */
const controlScanUrl = async (scanId, urlIndex, action) => {
  const response = await axios.post(`${API_URL}/${scanId}/urls/${urlIndex}/${action}`);
  return response.data;
};

const webVulnScanService = {
  createScan,
  startScan,
  getStatus,
  getResults,
  pauseScan,
  resumeScan,
  cancelScan,
  controlScanUrl,
  listScans,
  getScan,
  deleteScan,
  createActionsFromFindings,
  updateSIEMCorrelation
};

export default webVulnScanService;
